export default __webpack_public_path__ + "static/media/logo@3x.cfe192d5.png";